import { render } from "./MagazinEntryView.vue?vue&type=template&id=2fa5af18"
import script from "./MagazinEntryView.vue?vue&type=script&lang=js"
export * from "./MagazinEntryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__